import { commonTranslations } from './common'
import { menuTranslations } from './menu'
import { authTranslations } from './auth'
import { companiesTranslations } from './companies'
import { branchesTranslations } from './branches'
import { customersTranslations } from './customers'
import { storesTranslations } from './stores'
import { inventoryTranslations } from './inventory'
import { taxesTranslations } from './taxes'
import { invoicesTranslations } from './invoices'
import { journalTranslations } from './journal'
import { chartOfAccountsTranslations } from './chartOfAccounts'
import { vendorsTranslations } from './vendors'
import { usersTranslations } from './users'
import { dashboardTranslations } from './dashboard'
import { loyaltyTranslations } from './loyalty'
import { settingsTranslations } from './settings'
import { reportsTranslations } from './reports'
import { webhooksTranslations } from './webhooks'
import { permissionsTranslations } from './permissions'
import { salesRepsTranslations } from './salesReps'
import { budgetsTranslations } from './budgets'
import { licenseTranslations } from './license'
import { updatesTranslations } from './updates'
import { restorePointsTranslations } from './restorePoints'
import { vouchersTranslations } from './vouchers'
import { bookLocationsTranslations } from './bookLocations'
import { documents } from './documents'
import { companySettingsTranslations } from './companySettings'
import { quotationsTranslations } from './quotations'
import { purchaseOrdersTranslations } from './purchaseOrders'
import { landedCostsTranslations } from './landedCosts'
import { medicineTrackingTranslations } from './medicineTracking'
import { shiftsTranslations } from './shifts'
import { tablesTranslations } from './tables'
import { notionTranslations } from './notion'
import { operationTypesTranslations } from './operationTypes'
import { municipalityTranslations } from './municipality'
import { eyewearTranslations } from './eyewear'
import { modifiersTranslations } from './modifiers'
import { tabsTranslations } from './tabs'
import { items as itemsTranslations } from './items'

export const translations = {
  ar: {
    common: commonTranslations.ar,
    menu: menuTranslations.ar,
    auth: authTranslations.ar,
    companies: companiesTranslations.ar,
    branches: branchesTranslations.ar,
    customers: customersTranslations.ar,
    stores: storesTranslations.ar,
    inventory: inventoryTranslations.ar,
    taxes: taxesTranslations.ar,
    journal: journalTranslations.ar,
    chartOfAccounts: chartOfAccountsTranslations.ar,
    invoices: invoicesTranslations.ar,
    vendors: vendorsTranslations.ar,
    users: usersTranslations.ar,
    dashboard: dashboardTranslations.ar,
    loyalty: loyaltyTranslations.ar,
    settings: settingsTranslations.ar,
    reports: reportsTranslations.ar,
    webhooks: webhooksTranslations.ar,
    permissions: permissionsTranslations.ar,
    salesReps: salesRepsTranslations.ar,
    budgets: budgetsTranslations.ar,
    license: licenseTranslations.ar,
    updates: updatesTranslations.ar,
    restorePoints: restorePointsTranslations.ar,
    vouchers: vouchersTranslations.ar,
    bookLocations: bookLocationsTranslations.ar,
    documents: documents.ar,
    companySettings: companySettingsTranslations.ar,
    quotations: quotationsTranslations.ar,
    medicineTracking: medicineTrackingTranslations.ar,
    shifts: shiftsTranslations.ar,
    tables: tablesTranslations.ar,
    notion: notionTranslations.ar,
    operationTypes: operationTypesTranslations.ar,
    municipality: municipalityTranslations.ar,
    purchaseOrders: purchaseOrdersTranslations.ar,
    landedCosts: landedCostsTranslations.ar,
    eyewear: eyewearTranslations.ar,
    modifiers: modifiersTranslations.ar,
    tabs: tabsTranslations.ar,
    items: itemsTranslations.ar,
  },
  en: {
    common: commonTranslations.en,
    menu: menuTranslations.en,
    auth: authTranslations.en,
    companies: companiesTranslations.en,
    branches: branchesTranslations.en,
    customers: customersTranslations.en,
    stores: storesTranslations.en,
    inventory: inventoryTranslations.en,
    taxes: taxesTranslations.en,
    journal: journalTranslations.en,
    chartOfAccounts: chartOfAccountsTranslations.en,
    invoices: invoicesTranslations.en,
    vendors: vendorsTranslations.en,
    users: usersTranslations.en,
    dashboard: dashboardTranslations.en,
    loyalty: loyaltyTranslations.en,
    settings: settingsTranslations.en,
    reports: reportsTranslations.en,
    webhooks: webhooksTranslations.en,
    permissions: permissionsTranslations.en,
    salesReps: salesRepsTranslations.en,
    budgets: budgetsTranslations.en,
    license: licenseTranslations.en,
    updates: updatesTranslations.en,
    restorePoints: restorePointsTranslations.en,
    vouchers: vouchersTranslations.en,
    bookLocations: bookLocationsTranslations.en,
    documents: documents.en,
    companySettings: companySettingsTranslations.en,
    quotations: quotationsTranslations.en,
    purchaseOrders: purchaseOrdersTranslations.en,
    landedCosts: landedCostsTranslations.en,
    medicineTracking: medicineTrackingTranslations.en,
    shifts: shiftsTranslations.en,
    tables: tablesTranslations.en,
    notion: notionTranslations.en,
    operationTypes: operationTypesTranslations.en,
    municipality: municipalityTranslations.en,
    eyewear: eyewearTranslations.en,
    modifiers: modifiersTranslations.en,
    tabs: tabsTranslations.en,
    items: itemsTranslations.en,
  },
  fr: {
    common: (commonTranslations as any).fr || commonTranslations.en,
    menu: (menuTranslations as any).fr || menuTranslations.en,
    auth: (authTranslations as any).fr || authTranslations.en,
    companies: (companiesTranslations as any).fr || companiesTranslations.en,
    branches: (branchesTranslations as any).fr || branchesTranslations.en,
    customers: (customersTranslations as any).fr || customersTranslations.en,
    stores: (storesTranslations as any).fr || storesTranslations.en,
    inventory: (inventoryTranslations as any).fr || inventoryTranslations.en,
    taxes: (taxesTranslations as any).fr || taxesTranslations.en,
    journal: (journalTranslations as any).fr || journalTranslations.en,
    chartOfAccounts: (chartOfAccountsTranslations as any).fr || chartOfAccountsTranslations.en,
    invoices: (invoicesTranslations as any).fr || invoicesTranslations.en,
    vendors: (vendorsTranslations as any).fr || vendorsTranslations.en,
    users: (usersTranslations as any).fr || usersTranslations.en,
    dashboard: (dashboardTranslations as any).fr || dashboardTranslations.en,
    loyalty: (loyaltyTranslations as any).fr || loyaltyTranslations.en,
    settings: (settingsTranslations as any).fr || settingsTranslations.en,
    reports: (reportsTranslations as any).fr || reportsTranslations.en,
    webhooks: (webhooksTranslations as any).fr || webhooksTranslations.en,
    permissions: (permissionsTranslations as any).fr || permissionsTranslations.en,
    salesReps: (salesRepsTranslations as any).fr || salesRepsTranslations.en,
    budgets: (budgetsTranslations as any).fr || budgetsTranslations.en,
    license: (licenseTranslations as any).fr || licenseTranslations.en,
    updates: (updatesTranslations as any).fr || updatesTranslations.en,
    restorePoints: (restorePointsTranslations as any).fr || restorePointsTranslations.en,
    vouchers: (vouchersTranslations as any).fr || vouchersTranslations.en,
    bookLocations: (bookLocationsTranslations as any).fr || bookLocationsTranslations.en,
    documents: (documents as any).fr || documents.en,
    companySettings: (companySettingsTranslations as any).fr || companySettingsTranslations.en,
    quotations: (quotationsTranslations as any).fr || quotationsTranslations.en,
    purchaseOrders: (purchaseOrdersTranslations as any).fr || purchaseOrdersTranslations.en,
    landedCosts: landedCostsTranslations.fr,
    medicineTracking: (medicineTrackingTranslations as any).fr || medicineTrackingTranslations.en,
    shifts: (shiftsTranslations as any).fr || shiftsTranslations.en,
    tables: (tablesTranslations as any).fr || tablesTranslations.en,
    notion: (notionTranslations as any).fr || notionTranslations.en,
    operationTypes: (operationTypesTranslations as any).fr || operationTypesTranslations.en,
    municipality: (municipalityTranslations as any).fr || municipalityTranslations.en,
    eyewear: (eyewearTranslations as any).fr || eyewearTranslations.en,
    modifiers: (modifiersTranslations as any).fr || modifiersTranslations.en,
    tabs: tabsTranslations.fr,
    items: (itemsTranslations as any).fr || itemsTranslations.en,
  },
}

